import React from 'react';

import { bind } from 'bind-decorator';

import ClinicalNumeric from '../../../../clinical/clinical-numeric';
import CalculatedLabel from '../../../calculated-label';

interface IProps {
  errored?: boolean;
  height: number;
  warning?: boolean;
  weight: number;

  onChange: (value: string) => void;
}

class BMIFieldEdit extends React.Component<IProps> {
  render() {
    const { errored, height, warning, weight } = this.props;
    return (
      <div>
        Height:{' '}
        <ClinicalNumeric
          inline={true}
          errored={errored}
          warning={warning}
          value={height || 0}
          onChange={this.onChangeHeight}
        />{' '}
        cm. Weight:{' '}
        <ClinicalNumeric
          inline={true}
          errored={errored}
          warning={warning}
          value={weight || 0}
          onChange={this.onChangeWeight}
        />{' '}
        kg. BMI: <CalculatedLabel inline={true} func="bmi" height={height} weight={weight} />
      </div>
    );
  }

  @bind
  private onChange(height: number, weight: number): void {
    const { onChange } = this.props;

    const res = { height: height, weight: weight };

    onChange(JSON.stringify(res));
  }

  @bind
  private onChangeHeight(height: number): void {
    const { weight } = this.props;

    this.onChange(height, weight);
  }

  @bind
  private onChangeWeight(weight: number): void {
    const { height } = this.props;

    this.onChange(height, weight);
  }
}

export default BMIFieldEdit;
